import {Component, Input, OnInit} from '@angular/core';
import {MatchTickerService} from '../../services/match-ticker/match-ticker.service';
import {AdCampaignService} from '@components/ad-campaign/services/ad-campaign.service';
import {AdCampaignPlacement} from '@api/models/ad-campaign/ad-campaign-placement';
import {EnvironmentService} from '@utils/services/environment/environment.service';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {IMatchTickerItem} from '@lib-modules/match/models/match-ticker-item';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'lib-match-ticker',
  templateUrl: './match-ticker.component.html',
  styleUrls: ['./match-ticker.component.scss']
})
export class MatchTickerComponent implements OnInit {
  protected readonly EnvironmentService = EnvironmentService;
  public readonly maxWidgetEntries = 15;
  private onlyVideos = false;
  public items: IMatchTickerItem[] = [];

  constructor( public matchTickerService: MatchTickerService,
               private adCampaignService: AdCampaignService,
               private route: ActivatedRoute) { }

  public ngOnInit(): void {
    this.adCampaignService.setPlacement(AdCampaignPlacement.Ticker);
    this.onlyVideos = this.route.snapshot.data['onlyVideos'] || false;
    if (this.onlyVideos) {
      this.items = this.matchTickerService.items.filter(item => item.videos_native?.length);
    } else {
      this.items = this.matchTickerService.items;
    }
  }

  public get colorScheme(): ColorScheme {
    return EnvironmentService.isWebsite ? ColorScheme.Dark : ColorScheme.Light;
  }
}
